module.exports = __webpack_public_path__ + "img/logout.909db4e9.png";